import { Directive } from '@angular/core';

@Directive({
  selector: 'glxy-alert-extended, [glxyAlertExtended]',
  host: {
    class: 'glxy-alert-extended',
  },
})
export class AlertExtendedDirective {}
